import HttpService from 'api/HttpService';
import {ChannelsService} from 'services/ChannelsService';
import {PlacementsService} from 'services/PlacementsService';
import {StatisticsService} from 'services/StatisticsService';
import {OrdersService} from 'services/OrdersService';
import {ProjectsService} from 'services/ProjectsService';
import {LabelsService} from 'services/LabelsService';
import {WebanalyticsService} from 'services/WebanalyticsService';
import {MetricsService} from 'services/MetricsService';
import {AdFormatsService} from 'services/AdFormatsService';
import {BidManagerAutostrategiesService} from 'services/BidManagerAutostrategiesService';
import {BidManagerProgressMetricsService} from 'services/BidManagerProgressMetricsService';
import {DashboardService} from 'services/DashboardService';
import {AccountsService} from './AccountsService';
import {AoriService} from './AoriService';
import {ConnectionsService} from 'services/ConnectionsService';
import {EnumsService} from 'services/EnumsService';
import {UserService} from 'services/UserService';
import {CurrencyService} from 'services/CurrencyService';
import {BidManagerService} from 'services/BidManagerService';
import {RolesService} from 'services/RolesService';
import {ConfigService} from 'services/ConfigService';
import {ReleaseNotesService} from 'services/ReleaseNotesService';
import {ContractsService} from 'services/ContractsService';
import {WebanalyticsConnectionsService} from 'services/WebanalyticsConnectionsService';
import {UTMService} from 'services/UTMService';
import {BalancingService} from 'services/BalancingService';
import {SearchService} from 'services/SearchService';
import {CustomMetricsService} from 'services/CustomMetricsService';
import {ColumnPresetsService} from 'services/ColumnPresetsService';
import {CustomersService} from 'services/CustomersService';
import {BrandsService} from 'services/BrandsService';
import {PayersService} from 'services/PayersService';
import {AdvertisersService} from 'services/AdvertisersService';
import {ManagersService} from 'services/ManagersService';
import GsExporterService from 'services/gsExporterService';


const channelsService = new ChannelsService(HttpService);
const placementsService = new PlacementsService(HttpService);
const statisticsService = new StatisticsService(HttpService);
const ordersService = new OrdersService(HttpService);
const projectsService = new ProjectsService(HttpService);
const labelsService = new LabelsService(HttpService);
const webanalyticsService = new WebanalyticsService(HttpService);
const metricsService = new MetricsService(HttpService);
const adFormatsService = new AdFormatsService(HttpService);
const bidManagerService = new BidManagerService(HttpService);
const bidManagerAutostrategiesService = new BidManagerAutostrategiesService(HttpService);
const bidManagerProgressMetricsService = new BidManagerProgressMetricsService(HttpService);
const dashboardService = new DashboardService(HttpService);
const accountsService = new AccountsService(HttpService);
const aoriService = new AoriService(HttpService);
const connectionsService = new ConnectionsService(HttpService);
const enumsService = new EnumsService(HttpService);
const userService = new UserService(HttpService);
const currencyService = new CurrencyService(HttpService);
const rolesService = new RolesService(HttpService);
const configService = new ConfigService(HttpService);
const releaseNotesService = new ReleaseNotesService(HttpService);
const contractsService = new ContractsService(HttpService);
const webanalyticsConnectionsService = new WebanalyticsConnectionsService(HttpService);
const utmService = new UTMService(HttpService);
const balancingService = new BalancingService(HttpService);
const searchService = new SearchService(HttpService);
const customMetricsService = new CustomMetricsService(HttpService);
const columnPresetsService = new ColumnPresetsService(HttpService);
const customersService = new CustomersService(HttpService);
const brandsService = new BrandsService(HttpService);
const payersService = new PayersService(HttpService);
const advertisersService = new AdvertisersService(HttpService);
const managersService = new ManagersService(HttpService);
const gsExporterService = new GsExporterService(HttpService);

window.setMetaMainMary = (key, val = false) => userService.setMeta({[key]: val});

export {
  channelsService,
  placementsService,
  statisticsService,
  ordersService,
  projectsService,
  labelsService,
  webanalyticsService,
  metricsService,
  adFormatsService,
  bidManagerService,
  bidManagerAutostrategiesService,
  bidManagerProgressMetricsService,
  dashboardService,
  accountsService,
  aoriService,
  connectionsService,
  enumsService,
  userService,
  currencyService,
  rolesService,
  configService,
  releaseNotesService,
  contractsService,
  webanalyticsConnectionsService,
  utmService,
  balancingService,
  searchService,
  customMetricsService,
  columnPresetsService,
  customersService,
  brandsService,
  payersService,
  advertisersService,
  managersService,
  gsExporterService
};
